export class ValidationError extends Error {
    static $inject = ['message', 'translationKey'];
    constructor(message, translationKey) {
        super(message);
        this.translationKey = translationKey;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ValidationError.prototype);
    }
}
